(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('SubscribeDialogController', SubscribeDialogController);

    SubscribeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Subscribe', 'Race', 'Runner'];

    function SubscribeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Subscribe, Race, Runner) {
        var vm = this;

        vm.subscribe = entity;
        vm.clear = clear;
        vm.save = save;
        vm.races = Race.query();
        vm.runners = Runner.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.subscribe.id !== null) {
                Subscribe.update(vm.subscribe, onSaveSuccess, onSaveError);
            } else {
                Subscribe.save(vm.subscribe, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:subscribeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
